import { Web3Wrapper } from '@0x/web3-wrapper';
import { createRoninConnector, createRoninMobileConnector, RoninNotFoundError, RoninNotUnlockedError, } from '@axieinfinity/connect';
import { getDomainAndURI, isMobileDevice } from './helpers';
export { RoninNotFoundError, RoninNotUnlockedError };
const applink = 'https://wallet.roninchain.com';
const walletDeepLink = 'roninwallet://';
let connector;
let web3Wrapper;
async function createWeb3(connector) {
    if (connector && connector?.provider) {
        web3Wrapper = new Web3Wrapper(connector.provider);
        connector = connector;
        return {
            web3Wrapper,
            connector,
        };
    }
    const isMobile = isMobileDevice();
    if (isMobile) {
        connector = createRoninMobileConnector();
        connector.on('display_uri', uri => {
            const encoded = encodeURIComponent(uri);
            const url = `${applink}/auth-connect?uri=${encoded}`;
            window.open(url, '_self');
        });
        await connector.connect();
        if (connector.provider) {
            return {
                web3Wrapper: new Web3Wrapper(connector.provider),
                connector,
            };
        }
        else
            throw new RoninNotFoundError();
    }
    else {
        connector = createRoninConnector();
        await connector.connect();
        if (connector.provider) {
            const web3Wrapper = new Web3Wrapper(connector.provider);
            const accounts = await web3Wrapper.getAvailableAddressesAsync();
            if (accounts.length < 1)
                throw new RoninNotUnlockedError();
            return {
                web3Wrapper,
                connector,
            };
        }
        throw new RoninNotFoundError();
    }
}
async function getWeb3Wrapper(newConnector) {
    if (connector && web3Wrapper)
        return {
            web3Wrapper,
            connector,
        };
    return createWeb3(newConnector);
}
async function getWeb3QRCodeWrapper({ onDisplayUri, }) {
    const connector = createRoninMobileConnector();
    connector.on('display_uri', uri => {
        onDisplayUri(uri);
    });
    await connector.connect();
    return {
        web3Wrapper: new Web3Wrapper(connector.provider),
        connector,
    };
}
function dispose() {
    if (connector) {
        connector.removeAllListeners();
        connector.disconnect();
        connector = undefined;
    }
}
function checkIsExtensionInstalled() {
    if (typeof window !== 'undefined') {
        return window.ronin !== undefined;
    }
    return false;
}
function isRoninNotFoundError(error) {
    return error?.code === 1004;
}
function generateSingingMessage({ address, version = 1, chainId = 2020, nonce, issuedAt, expirationTime, notBefore, }) {
    const { domain, uri } = getDomainAndURI();
    return `${domain} wants you to sign in with your Ronin account:
${address.replace('0x', 'ronin:').toLowerCase()}

I accept the Terms of Use (https://axieinfinity.com/terms-of-use) and the Privacy Policy (https://axieinfinity.com/privacy-policy)

URI: ${uri}
Version: ${version}
Chain ID: ${chainId}
Nonce: ${nonce}
Issued At: ${issuedAt}
Expiration Time: ${expirationTime}
Not Before: ${notBefore}`;
}
const toRoninWalletUniversalLink = (uri, prefix) => {
    prefix = prefix ?? 'https://wallet.roninchain.com/';
    const encoded = encodeURIComponent(uri);
    return `${prefix}auth-connect?uri=${encoded}`;
};
const toRoninWalletDeepLink = (uri, prefix) => {
    prefix = prefix ?? 'roninwallet://';
    const encoded = encodeURIComponent(uri);
    return `${prefix}auth-connect?uri=${encoded}`;
};
const clearWalletconnectV2Storage = () => {
    const walletconnectV2Keys = Object.keys(localStorage).filter(key => key.startsWith('wc@2'));
    // Support v1
    localStorage.removeItem('walletconnect');
    walletconnectV2Keys.map(key => localStorage.removeItem(key));
};
const openWalletApp = () => {
    window.open(applink, '_self');
};
export { getWeb3Wrapper, getWeb3QRCodeWrapper, dispose, checkIsExtensionInstalled, generateSingingMessage, isRoninNotFoundError, toRoninWalletUniversalLink, toRoninWalletDeepLink, clearWalletconnectV2Storage, openWalletApp, applink as walletUniversalLink, walletDeepLink, };
//# sourceMappingURL=web3.js.map